import Encryption from "./encription";

const get_l10n = (l10n) => {
  if ( typeof l10n === 'string' ) {
    return Object.assign({}, JSON.parse((new Encryption()).decrypt(l10n, 'grind')));
  }
  return l10n;
}

export const media_l10n = get_l10n(window.wppr_media_l10n);
const l10n = get_l10n(window.cropper_l10n);
// console.log(l10n);
l10n.__getvar = ( name ) => Object.keys(l10n).reduce(
  (accumulator, currentKey) => {
    if(currentKey.indexOf( name ) === 0) {
      const key = currentKey.substring(name.length, currentKey.length);
      const value = l10n[currentKey];
      accumulator[key] = value;
    }
    return accumulator;
  },
  {}
);
export default l10n;